<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-10-19 17:40:52
--> 
<template>
  <v-menu offset-y
          transition="scale-transition">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-btn icon>
          <!-- <v-icon>mdi-dots-vertical</v-icon> -->
          <slot name="showAction"></slot>
        </v-btn>
      </span>
    </template>
    <v-list dense>
      <v-list-item @click="handleClick(item,index)"
                   v-for="(item, index) in showList"
                   v-show="item.show"
                   :key='index'>
        <v-list-item-title>{{item.name}}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {

    };
  },
  created () { },
  mounted () {

  },
  methods: {
    handleClick (item, index) {
      this.$emit('handleClick', { item, index })
    }
  },
  computed: {
    showList: {
      get () {
        if (this.list.length > 0) {
          return this.list
        } else {
          return [
            {
              name: this.$t('label_View'),
              type: 'view'
            },
            {
              name: this.$t('label_Edit'),
              type: 'edit'
            },
            {
              name: this.$t('label_delete'),
              type: 'del'
            }
          ]
        }
      }
    }
  },
  watch: {},
};
</script>

<style scoped>
.v-list {
  padding: 0;
}
.v-list-item {
  width: 124px;
  height: 48px;
  max-height: 48px;
}
</style>
